<template>
 <v-parallax dark :src="divider.url" :height="getHeight" class="hidden-sm-and-down pa-0 test">
      <!-- <img :src="divider.url" :alt="divider.alt"/> -->
      <!-- <img class="overlayer pa-0 ml-n16" :src="divider.overlayUrl" alt=""> -->
  </v-parallax>
</template>

<script>

export default {
  name: 'Divider',
  props: ["divider"],
  computed: {
    getHeight() {
      const {mdAndDown } = this.$vuetify.breakpoint
        return mdAndDown ? 400 : 600;
    }
  }
}
</script>


<style lang="scss" scoped>
  .overlayer {
    min-width: 120%;
    opacity: 0.5;
  }

  .v-parallax__content {
    padding: 0px !important;
  }
</style>